import { CancelButton, SaveButton } from '@core/components/Buttons';
import { SimpleDialogContent } from '@core/components/Dialog';
import { SearchBar } from '@core/components/SearchBar';
import { SimpleTable } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit, TableActionContainer } from '@core/components/TableAction';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Grid } from '@material-ui/core';
import { ClienteContext } from 'app/main/cliente/ClienteContext';
import { excluirAlert } from 'app/services/alerts';
import { grupoClienteApi } from 'app/services/api/grupoClienteApi';
import * as Actions from 'app/store/actions';
import { eventReactGA } from 'app/utils/analyticsUtil';
import React, { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GrupoClienteContext } from '../../GrupoClienteContext';

const GRUPO_CLIENTE = 'Grupo de cliente';

const ListagemGrupoCliente = ({ fetchGruposCliente }) => {
  const [, setFormulario] = useContext(GrupoClienteContext).formulario;
  const [, setModal] = useContext(ClienteContext).modal;
  const [gruposCliente] = useContext(GrupoClienteContext).gruposCliente;
  const [, setGrupoCliente] = useContext(GrupoClienteContext).grupoCliente;
  const [loading, setLoading] = useContext(GrupoClienteContext).loading;
  const [totalElements] = useContext(GrupoClienteContext).totalElements;
  const [page, setPage] = useContext(GrupoClienteContext).page;
  const [size, setSize] = useContext(GrupoClienteContext).size;
  const [sort] = useContext(GrupoClienteContext).sort;
  const [search, setSearch] = useContext(GrupoClienteContext).search;

  useReduxLoading(loading);

  useEffect(() => {
    setSearch('');
  }, [setSearch]);

  const handleEdit = async (grupoClienteId) => {
    try {
      const resp = await grupoClienteApi().buscarGrupoClientePorId(grupoClienteId);
      setGrupoCliente(resp.data);
      setFormulario('cadastro');
    } catch (error) {}
  };

  const handleCadastro = () => {
    setFormulario('cadastro');
  };

  const dispatch = useDispatch();

  useReduxLoading(loading);

  const apiUtils = useApiUtils(dispatch, Actions);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const handleCloseModal = () => {
    setModal('');
  };

  const handleRemove = (grupoToRemove) => {
    excluirAlert({
      confirmar: async () => {
        try {
          setLoading(true);
          eventReactGA(GRUPO_CLIENTE, 'Excluir grupo de cliente');
          await grupoClienteApi().removerGrupoCliente(grupoToRemove.id);
          showSuccess('Grupo de cliente excluído com sucesso.');
          fetchGruposCliente({ q: search, page, size, sort });
        } catch (err) {
          apiUtils.handleApiError(err);
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const columns = [
    {
      name: 'nomeGrupo',
      title: 'Nome do grupo',
      align: 'left',
      hideTooltip: true,
      getCellValue: (option) => option?.nome,
      sortingEnabled: false,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 130,
      getCellValue: (grupo) => (
        <TableActionContainer>
          <>
            {permissaoUtils.cliente().editar && <TableActionButtonEdit onClick={() => handleEdit(grupo.id)} />}
            {permissaoUtils.cliente().excluir && (
              <TableActionButtonDelete onClick={() => handleRemove(grupo)} className={'stepIconeExcluir'} />
            )}
          </>
        </TableActionContainer>
      ),
    },
  ];

  return (
    <SimpleDialogContent
      innerScroll={false}
      header={{
        title: 'Buscar grupo de clientes',
        toolbar: (
          <>
            <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>

            <SaveButton id="add-classe-root" type="submit" onClick={handleCadastro}>
              Cadastrar
            </SaveButton>
          </>
        ),
      }}
      content={
        <div className="h-full max-h-full w-full">
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
              <SearchBar placeholder="Pesquisar" searchText={search} onChange={setSearch} />
            </Grid>
            <div style={{ width: '100%' }}>
              <SimpleTable
                getRowId={(row) => row}
                columns={columns}
                rows={gruposCliente}
                hideSelection
                fetchOnCreate
                fetchData={fetchGruposCliente}
                loading={loading}
                defaultSorting={[{ columnName: 'nome', direction: 'asc' }]}
                totalCount={totalElements}
                onCurrentPageChange={(params) => {
                  setPage(params);
                }}
                onPageSizeChange={(params) => {
                  setSize(params);
                }}
                onSortingChange={(params) => console.log(params)}
                onLoadingChange={(params) => console.log('loading change', params)}
                searchBy={search}
              />
            </div>
          </Grid>
        </div>
      }
    />
  );
};

export default ListagemGrupoCliente;
